import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../utils/request';
import { Result, Button } from 'antd';

export class Test extends Component {
    constructor(props) {
        super(props);      
    };
    render() {
        return (
            <Result
                extra={[
                    <br />,
                    <p style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>show test</p>,
                    <br />,
                    <p style={{ textAlign: "center", marginRight: "0" }}>
                        <Button  style={{ marginRight: "0" }}>同意</Button>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <Button type="primary"  style={{ marginLeft: "0" }}>拒绝</Button>
                    </p>
                ]} />
        );
    }
}
